import axiosInstance from "../api/axios";

/* ---------------- Planned maintenance windows (v4_3) ----------------
 * Replaces a fire-and-forget endpoint that stored nothing — and that had no authentication at all,
 * so anyone who could reach the API could mail and WhatsApp the whole platform. One window row now
 * drives the banner, the announcement email, the reminder and the admin status, so those cannot
 * disagree about when the platform is down.
 */

// The banner. Unauthenticated so it also works on the login screen — the only thing it discloses is
// that maintenance is scheduled, which is what we are trying to say.
export const getMaintenanceBanner = () => axiosInstance.get(`/public/maintenance/current`);

// --- Zumale admin ---
export const listMaintenance = (includePast) =>
  axiosInstance.get(`/admin/maintenance`, { params: includePast ? { includePast: true } : {} });

// Omit `message` and it is rendered from the per-type template.
export const scheduleMaintenance = (body) => axiosInstance.post(`/admin/maintenance`, body);

// Changing the times re-arms the announcement, so nobody is left holding the old schedule.
export const amendMaintenance = (id, body) => axiosInstance.patch(`/admin/maintenance/${id}`, body);

export const cancelMaintenance = (id, reason) =>
  axiosInstance.post(`/admin/maintenance/${id}/cancel`, { reason });
